<li class="link d-flex align-items-center">
    <a *ngIf="link" routerLink="{{ link }}" routerLinkActive="active">
        <ng-container *ngTemplateOutlet="linkWithIcons"></ng-container>
    </a>
    <a *ngIf="externalLink" href="{{ externalLink }}" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="linkWithIcons"></ng-container>
    </a>
</li>

<ng-template #linkWithIcons>
    <ca-icon class="icon-in-front-of-text" [name]="iconName" size="xs" [highlightMode]="highlightMode"></ca-icon>
    <span class="font-m">{{ linkName }}</span>
    <ca-icon *ngIf="iconName2" class="icon-after-text" [name]="iconName2" size="xs" [highlightMode]="highlightMode"></ca-icon>
</ng-template>
